/**
 * VIB-1142: Ved konvertering tilbud → prosjekt velger PL hvilke
 * tilvalgsseksjoner som skal med. Hovedlinjer (section_id == null) er alltid
 * med; tilvalg-linjer tas kun med hvis seksjonen er huket av.
 */
export function selectTilvalgLines<T extends { section_id?: string | null }>(
  lines: T[],
  selectedSectionIds: Set<string>,
): T[] {
  return lines.filter(
    (l) => l.section_id == null || selectedSectionIds.has(l.section_id),
  );
}

/** Sum av `amount` for et sett linjer (NOK); null/undefined teller som 0. */
export function sumLinesAmount<T extends { amount?: number | null }>(
  lines: T[],
): number {
  return lines.reduce((s, l) => s + (l.amount ?? 0), 0);
}
